export default __webpack_public_path__ + "1645f50fb7f7c109f64eedae92080228.woff";